import React from 'react';
import { Pane } from 'evergreen-ui';
import { DangerModeStatus, DataReceivedStatus, EnableModeStatus, StormModeStatus } from './Statuses';

export function DatasourceStatuses({ datasourceId }: {datasourceId: number}) {
  return (
    <Pane display="flex" alignItems="center">
      <EnableModeStatus datasourceId={datasourceId} />
      <DangerModeStatus datasourceId={datasourceId} />
      <DataReceivedStatus datasourceId={datasourceId} />
      <StormModeStatus datasourceId={datasourceId} />
      {/* <SoftReleaseStatus datasourceId={datasourceId} /> */}
    </Pane>
  );
}
export const MemoDatasourceStatuses = React.memo(DatasourceStatuses);
MemoDatasourceStatuses.displayName = 'MemoDatasourceStatuses';
export default DatasourceStatuses;
